export const addListenerToMediaDevicesPermission = async (callBack: (value: any) => void) => {
  const permissions = ["microphone"]
  for (let i = 0; i < permissions.length; i++) {
    const state = await navigator.permissions.query({
      name: permissions[i],
    } as any)
    state.addEventListener("change", (event: any) => callBack({ [permissions[i]]: event.target.state }))
  }
}
